import { BroadcastifyFeeds } from 'features/broadcastify/components/BroadcastifyFeeds';
import { ExternalGeoEvent } from 'shared/types';

type ExternalGeoEventBroadcastifyProps = {
  event: ExternalGeoEvent;
};

export const ExternalGeoEventBroadcastify = (
  props: ExternalGeoEventBroadcastifyProps,
): JSX.Element => {
  const { event } = props;

  return (
    <BroadcastifyFeeds lat={event.lat} lng={event.lng} withHeader={false} />
  );
};
